var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MhRouterView',{staticClass:"HomeView view hSpace hSpace--app",attrs:{"isContentReady":_vm.isContentReady}},[_c('div',{staticClass:"HomeView__inner view__inner"},[_c('DocCreateForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }